"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostpaidIntent = exports.pageMap = exports.EventCode = exports.PageURLs = exports.Action = exports.StatusMessage = exports.StatusCode = exports.WrlsLinkPositionDataKeysOptions = exports.BuyFlowViews = exports.LinkPositionDataKeysOptions = exports.EventActions = exports.ErrorTypeOption = exports.SuccessFlags = void 0;
var SuccessFlags;
(function (SuccessFlags) {
    /** User’s action was successful */
    SuccessFlags[SuccessFlags["SUCCESSFUL"] = 1] = "SUCCESSFUL";
    /** User’s action unsuccessful
     * (system errors, e.g. back end system down or unrecognized user input/blank fields/etc.
     */
    SuccessFlags[SuccessFlags["UNSUCCESSFUL"] = 0] = "UNSUCCESSFUL";
    /** User cancelled the action */
    SuccessFlags[SuccessFlags["USER_CANCEL"] = -1] = "USER_CANCEL";
    /** Unknown */
    SuccessFlags[SuccessFlags["UNKNOWN"] = -2] = "UNKNOWN";
})(SuccessFlags = exports.SuccessFlags || (exports.SuccessFlags = {}));
var ErrorTypeOption;
(function (ErrorTypeOption) {
    ErrorTypeOption["Success_Admit"] = "Success_Admit";
    ErrorTypeOption["Planned_Downtime"] = "Planned_Downtime";
    ErrorTypeOption["Failure_BusinessRule"] = "Planned_Downtime";
    ErrorTypeOption["Failure_User"] = "Failure_User";
    ErrorTypeOption["Failure_System"] = "Failure_System";
    ErrorTypeOption["Failure_Data"] = "Failure_Data";
    ErrorTypeOption["UNKNOWN"] = "";
})(ErrorTypeOption = exports.ErrorTypeOption || (exports.ErrorTypeOption = {}));
/*** Event actions types. */
var EventActions;
(function (EventActions) {
    EventActions["PAGE_LOAD"] = "pageLoad";
    EventActions["LINK_CLICK"] = "linkClick";
    EventActions["SYSTEM_EVENT"] = "systemEvent";
    EventActions["FORM_RESPONSE"] = "formResponse";
    EventActions["FORM_SUBMIT"] = "formSubmit";
    EventActions["IMPRESSION"] = "impression";
    EventActions["MARKETING"] = "marketing";
})(EventActions = exports.EventActions || (exports.EventActions = {}));
var LinkPositionDataKeysOptions;
(function (LinkPositionDataKeysOptions) {
    LinkPositionDataKeysOptions["GLBN"] = "GLBN";
    LinkPositionDataKeysOptions["SUB_NAV"] = "SubNav";
    LinkPositionDataKeysOptions["LEFT_NAV"] = "LeftNav";
    LinkPositionDataKeysOptions["RIGHT_NAV"] = "RightNav";
    LinkPositionDataKeysOptions["BODY"] = "Body";
    LinkPositionDataKeysOptions["BODY_ALERTS"] = "Body_Alerts";
    LinkPositionDataKeysOptions["BODY_LOGIN_WIDGET"] = "Body_LoginWidget";
    LinkPositionDataKeysOptions["BODY_MESSAGE"] = "Body_Message";
    LinkPositionDataKeysOptions["MARQUEE"] = "Marquee";
    LinkPositionDataKeysOptions["CAROUSEL"] = "Carousel";
    LinkPositionDataKeysOptions["TAB"] = "Tab";
    LinkPositionDataKeysOptions["LINK_FARM"] = "LinkFarm";
    LinkPositionDataKeysOptions["FOOTER"] = "Footer";
    LinkPositionDataKeysOptions["HEADER"] = "Header";
    LinkPositionDataKeysOptions["QUICK_LINKS"] = "QuickLinks";
    LinkPositionDataKeysOptions["LINK_FARM_1"] = "LinkFarm_1";
    LinkPositionDataKeysOptions["LINK_FARM_2"] = "LinkFarm_2";
    LinkPositionDataKeysOptions["LINK_FARM_3"] = "LinkFarm_3";
})(LinkPositionDataKeysOptions = exports.LinkPositionDataKeysOptions || (exports.LinkPositionDataKeysOptions = {}));
var BuyFlowViews;
(function (BuyFlowViews) {
    BuyFlowViews["CAROUSEL"] = "carousel";
    BuyFlowViews["CONFIG"] = "config";
    BuyFlowViews["INSURANCE_SELECT"] = "insurance_select";
    BuyFlowViews["INSURANCE_DETAIL"] = "insurance_detail";
    BuyFlowViews["COLLAPSED"] = "collapsed";
    BuyFlowViews["BYOD"] = "byod";
    BuyFlowViews["BYOD_EXPANDED"] = "byod_expanded";
    BuyFlowViews["INTERSTITAL"] = "offer-interstitial";
})(BuyFlowViews = exports.BuyFlowViews || (exports.BuyFlowViews = {}));
var WrlsLinkPositionDataKeysOptions;
(function (WrlsLinkPositionDataKeysOptions) {
    WrlsLinkPositionDataKeysOptions["MODEL"] = "MODEL";
    WrlsLinkPositionDataKeysOptions["BODY"] = "BODY";
})(WrlsLinkPositionDataKeysOptions = exports.WrlsLinkPositionDataKeysOptions || (exports.WrlsLinkPositionDataKeysOptions = {}));
var StatusCode;
(function (StatusCode) {
    StatusCode[StatusCode["SUCCESS"] = 0] = "SUCCESS";
    StatusCode[StatusCode["USER_CANCEL"] = -1] = "USER_CANCEL";
    StatusCode[StatusCode["UNKNOWN"] = -2] = "UNKNOWN";
    StatusCode["S_200"] = "200";
    StatusCode["S_400"] = "400";
    StatusCode["S_404"] = "404";
})(StatusCode = exports.StatusCode || (exports.StatusCode = {}));
var StatusMessage;
(function (StatusMessage) {
    StatusMessage["SUCCESS"] = "SUCCESS";
    StatusMessage["FAILURE"] = "Failure";
    StatusMessage["NOTFOUND"] = "Not Found";
    StatusMessage["VENDORCONFLICT"] = "Vendor Conflict";
})(StatusMessage = exports.StatusMessage || (exports.StatusMessage = {}));
var Action;
(function (Action) {
    Action["ADD"] = "add";
    Action["CHANGE"] = "change";
    Action["REMOVE"] = "remove";
})(Action = exports.Action || (exports.Action = {}));
var PageURLs;
(function (PageURLs) {
    PageURLs["ADD_TO_CART_CONFIG_MODAL"] = "addtocartconflict/modal";
    PageURLs["COMPATIBLE_DEVICE"] = "compatibledevice/modal";
    PageURLs["LNP_MODEL"] = "porting/modal";
    PageURLs["PLANDETAIL"] = "plandetails";
    PageURLs["BYOD"] = "byod";
    PageURLs["PLAN"] = "plans";
    PageURLs["EXISTINGPLANS"] = "existingplans";
    PageURLs["ENTERTAINMENT"] = "entertainment";
    PageURLs["DEVICES"] = "devices";
    PageURLs["DEVICE_CONFIG"] = "deviceconfig";
    PageURLs["DEVICE_CONFIG_MODAL"] = "deviceconfig/modal";
    PageURLs["INSURANCE_DETAILS"] = "insurancedetails";
    PageURLs["INSURANCE"] = "insurance";
    PageURLs["DEVICE_DETAILS"] = "devicedetails/modal";
    PageURLs["DEVICE_LEGAL"] = "devicelegal/modal";
    PageURLs["DEVICE_PLAN_CHANGE"] = "deviceplanchange/modal";
    PageURLs["INSURANCE_LEGAL"] = "insurancelegal/modal";
    PageURLs["TRADE_IN_OFFER"] = "tradeinoffer/modal";
    PageURLs["TRADE_IN_OFFER_DETAILS"] = "tradeinofferdetails/modal";
    PageURLs["HOW_TO_TRADE_IN"] = "howtotradein/modal";
    PageURLs["LNP_OFFER_MODAL"] = "lnpofferdetails/modal";
    PageURLs["TRADE_IN"] = "tradein";
    PageURLs["TRADEIN_MODAL"] = "tradeindetail/modal";
    PageURLs["LNP"] = "lnp";
    PageURLs["PLAN_LEGAL"] = "planlegal/modal";
    PageURLs["STORE_LIST"] = "storelist";
    PageURLs["PORTING"] = "porting/modal";
    PageURLs["SAME_PAGE"] = "";
    PageURLs["CRP"] = "changerateplan";
    PageURLs["CLICKTOSTORE"] = "storelist/modal";
    PageURLs["INTERSTITAL"] = "offer-interstitial";
    PageURLs["UPSELLINTERSTITAL"] = "upsell-offer-interstitial";
    PageURLs["FILTER_OPTIONS_MODAL"] = "filteroptions/modal";
    PageURLs["ERROR_MODAL"] = "cto/modal";
    PageURLs["PLAN_DISCOUNT_MODAL"] = "plandiscount/modal";
    PageURLs["HEADS_UP_MODAL"] = "insurance/declineconfirm/modal";
    PageURLs["OFFER_LEGAL"] = "offerlegal/modal";
    PageURLs["BYOD_ACTIVATION"] = "/prepaid/activations/#/activate.html";
    PageURLs["ACCESSORIES"] = "accessories";
    PageURLs["ACCESSORY_CONFIG"] = "accessoryconfig";
    PageURLs["CONDITION_WHATSTHIS"] = "devicecondition/modal";
    PageURLs["CONFLICT_MODAL"] = "deviceconfigconflict/modal";
    PageURLs["UPGRADE_ELIGIBILITY"] = "upgrade-eligibility";
    PageURLs["UPGRADEOPTIONS_MODAL"] = "upgradeoptions/modal";
    PageURLs["SPECIAL_OFFER_MODAL"] = "specialoffer/modal";
    PageURLs["DUAL_SIM_MODAL"] = "dualsim/modal";
    PageURLs["CROSSLOB_CONFLICT"] = "conflict/modal";
    PageURLs["CHANGEPLAN_CONFLICT"] = "changeplan/modal";
    PageURLs["REPLACECART_CONFLICT"] = "replacecart/modal";
    PageURLs["INTENT_MODAL"] = "intent/modal";
    PageURLs["FINDYOURIMEINUMBER_MODAL"] = "findyourimeinumber/modal";
    PageURLs["FINDYOURICCIDNUMBER_MODAL"] = "findyouriccidnumber/modal";
    PageURLs["FINDYOUREIDNUMBER_MODAL"] = "findyoureidnumber/modal";
    PageURLs["HARD_STOP"] = "hardstop";
    PageURLs["CHECKOUT"] = "/buy/checkout/checkoutview";
    PageURLs["JOINGROUP_HARD_STOP"] = "joingroup/cto";
    PageURLs["BUY_CART_PAGE_URL"] = "/buy/cart";
    PageURLs["CHECKOUT_PAGE_URL"] = "/buy/checkout/checkoutview";
    PageURLs["WIRELESS_URL"] = "/buy/wireless/";
    PageURLs["EDIT_DEVICE_URL"] = "/buy/wireless/devices";
    PageURLs["CUSTOMIZE_URL"] = "/buy/wireless/deviceconfig";
    PageURLs["EDIT_PLANS_URL"] = "/buy/wireless/plans";
    PageURLs["EDIT_TRADEIN_URL"] = "/buy/wireless/tradeIn";
    PageURLs["EDIT_INSURANCE_URL"] = "/buy/wireless/insurance";
    PageURLs["SIGNATURE_LEGAL_MODAL"] = "legal/signaturebenefits/modal";
    PageURLs["PRICE_BREAKDOWN_MODAL"] = "deviceconfig/pricebreakdown/modal";
    PageURLs["CHOOSE_LINENUMBER_SYNC"] = "chooselinenumbersync";
    PageURLs["CHOOSE_LINENUMBER_SYNC_MODAL"] = "numbersynclearn/modal";
    PageURLs["NUMBER_SYNC_DETAILS_MODAL"] = "numbersyncdetails/modal";
    PageURLs["PLAN_LEGAL_MODAL"] = "planlegal/modal";
})(PageURLs = exports.PageURLs || (exports.PageURLs = {}));
var EventCode;
(function (EventCode) {
    EventCode["LNP_CHECK_SUBMIT"] = "DS_Wireless_LNP_Check_Submit";
    EventCode["DS_ADD_TO_CART_SUBMIT"] = "DS_Add_To_Cart_Submit";
    EventCode["EAP_DEVICEINFORMATION_SUBMIT"] = "EAP_DeviceInformation_Submit";
    EventCode["DS_UPDATE_TO_CART_SUBMIT"] = "DS_Cart_Update_Submit";
    EventCode["DS_REMOVE_CART_SUBMIT"] = "DS_Remove_Cart_Submit";
    EventCode["DS_UPGRADE_PLAN_SUBMIT"] = "DS_UPGRADE_PLAN_SUBMIT";
    EventCode["FILTER_SELECTION"] = "DS_Device_List_Filter_Click";
    EventCode["DS_DEVICEDETAILS_CLICK"] = "DS_DeviceDetails_Click";
    EventCode["DS_TRADEIN_REQUEST_SUBMIT"] = "DS_TradeIn_Request_Submit";
    EventCode["DS_TRADEIN_MAKEMODEL_SUBMIT"] = "DS_TradeIn_MakeModel_Selection_Submit";
    EventCode["DS_REMOVE_TRADEIN_SUBMIT"] = "DS_Remove_TradeIn_Submit";
    EventCode["PAGE_LOAD"] = "Page_Load";
    EventCode["LINK_CLICK"] = "Link_Click";
    EventCode["DS_SYSTEM_DEVICE_LIST_DISPLAY"] = "DS_System_Device_List_Display";
    EventCode["DS_SYSTEM_GUIDED_OFFERS_DISPLAY"] = "DS_System_Guided_Offers_Display";
    EventCode["DS_SIM_REQUEST_SUBMIT"] = "DS_SIM_Request_Submit";
    EventCode["DS_System_Device_Config_Display"] = "DS_System_Device_Config_Display";
    EventCode["DS_SYSTEM_UPGRADE_ELIGIBILITY_DISPLAYED"] = "DS_System_Upgrade_Eligibility_Displayed";
    EventCode["DS_UPGRADE_SUBMIT"] = "DS_Upgrade_Submit";
    EventCode["DS_UPGRADE_OPTION_SUBMIT"] = "DS_Upgrade_Option_Submit";
    EventCode["DS_LEAD_CAPTURE_SUBMIT"] = "DS_Lead_Capture_Submit";
    EventCode["IMPRESSION"] = "impression";
    EventCode["DS_SYSTEM_CART_UPDATE_DISPLAY"] = "DS_System_Cart_Update_Display";
})(EventCode = exports.EventCode || (exports.EventCode = {}));
exports.pageMap = (_a = {},
    _a[BuyFlowViews.CAROUSEL] = { pageUrl: PageURLs.DEVICES, postfixPath: 'devices' },
    _a[BuyFlowViews.CONFIG] = { pageUrl: PageURLs.DEVICE_CONFIG, postfixPath: 'deviceconfig' },
    _a[BuyFlowViews.INSURANCE_DETAIL] = { pageUrl: PageURLs.INSURANCE_DETAILS, postfixPath: 'insurancedetails' },
    _a[BuyFlowViews.INSURANCE_SELECT] = { pageUrl: PageURLs.INSURANCE, postfixPath: 'insurance' },
    _a[BuyFlowViews.COLLAPSED] = { pageUrl: PageURLs.DEVICE_CONFIG, postfixPath: 'deviceconfig' },
    _a[BuyFlowViews.BYOD] = { pageUrl: PageURLs.BYOD, postfixPath: 'byod' },
    _a[BuyFlowViews.INTERSTITAL] = { pageUrl: PageURLs.INTERSTITAL, postfixPath: 'offer-interstitial' },
    _a);
var PostpaidIntent;
(function (PostpaidIntent) {
    PostpaidIntent["AL"] = "al";
    PostpaidIntent["UP"] = "up";
    PostpaidIntent["RYD"] = "ryd";
})(PostpaidIntent = exports.PostpaidIntent || (exports.PostpaidIntent = {}));
//# sourceMappingURL=Analytics.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/wireless-ui/models/Analytics.js
// module id = 810
// module chunks = 8